var WorkflowStepWarningModalController = /** @class */ (function () {
    function WorkflowStepWarningModalController() {
        // this.companyId = this.resolve.companyId;
        // this.clientOrBuId = this.resolve.clientOrBuId;
        // this.stepName = this.resolve.stepName;
        // this.message = this.resolve.message;
        // this.context = this.resolve.context;
    }
    WorkflowStepWarningModalController.prototype.$onInit = function () {
        this.companyId = this.resolve.companyId;
        this.clientOrBuId = this.resolve.clientOrBuId;
        this.stepName = this.resolve.stepName;
        this.message = this.resolve.message;
        this.context = this.resolve.context;
        this.callbackObject = { callbackType: 'cancel', entity: {} };
    };
    WorkflowStepWarningModalController.prototype.closeModal = function () {
        this.modalInstance.close(this.callbackObject);
    };
    WorkflowStepWarningModalController.prototype.dismissModal = function () {
        this.modalInstance.dismiss('cancel');
    };
    return WorkflowStepWarningModalController;
}());
// import * as TEMPLATE from './workflow-step-warning-modal.html';
import * as TEMPLATE from 'raw-loader!./workflow-step-warning-modal.html';
export var WorkflowStepWarningModalComponent = {
    selector: 'workflowStepWarningModal',
    component: {
        bindings: {
            modalInstance: "<",
            resolve: "<"
        },
        controller: WorkflowStepWarningModalController,
        template: TEMPLATE.default
        // templateUrl: 'app/partials/missioncontrol/company/workflowStepWarningModal/workflow-step-warning-modal.html'
    }
};
//# sourceMappingURL=workflow-step-warning-modal.component.js.map